import Vue from 'vue'
import Vuex from 'vuex'
import AppSettings from './util/appSettings'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    action: "watch",
    inventar: [],
    room: [{
        number: 0,
        title: 'Garage Eingang',
        roomimage: require('@/assets/room0/room0.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'Türe',
            description: '',
            value: '',
            img: '',
            position: [840, 200, 190, 420],
            taken: '',
            keyid: '',
            linkedroomid: 4,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'links',
            description: '',
            value: '',
            img: require('@/assets/leftbutton.gif'),
            position: [20, 700, 130, 130],
            taken: '',
            keyid: '',
            linkedroomid: 1,
            readonly: ''
          },
          2: {
            kind: 'human',
            title: 'Steve Jobs',
            description: 'Schau den Feuerlöscher genauer an... Hast du gewusst das Apple die Maus, den Touchscreen und das Telefon erfunden hat?',
            value: '',
            img: require('@/assets/stevejobs.png'),
            position: [200, 200, 230, 300],
            taken: '',
            keyid: '',
            linkedroomid: '',
            readonly: true
          },
          3: {
            kind: 'object',
            title: 'Notiz',
            description: 'Befreie die Katze im WC!',
            value: 'joycon1234',
            img: '',
            position: [1120, 290, 80, 100],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: true
          },
        }
      },
      {
        number: 1,
        title: 'Garage',
        roomimage: require('@/assets/room1/room1.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'Auto',
            description: 'Marco Rakete',
            value: '',
            img: '',
            position: [470, 300, 300, 240],
            taken: false,
            keyid: '',
            linkedroomid: 2,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/backbutton.gif'),
            position: [1120, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 0,
            readonly: ''
          }
        }
      },
      {
        number: 2,
        title: 'Parkplatz',
        roomimage: require('@/assets/room2/room2.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'Kofferraum',
            description: 'Mit dem Autoschlüssen kannst Du ihn öffnen!',
            value: '',
            img: '',
            position: [502, 260, 399, 190],
            taken: false,
            keyid: 'auto1234',
            linkedroomid: 3,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/backbutton.gif'),
            position: [1120, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 1,
            readonly: ''
          }
        }
      },
      {
        number: 3,
        title: 'Kofferraum',
        roomimage: require('@/assets/room3/room3.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/backbutton.gif'),
            position: [1120, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 2,
            readonly: ''
          },
          1: {
            kind: 'object',
            title: 'Joycon Controller',
            description: 'Linker Nintendo Switch Controller',
            value: 'joycon1234',
            img: require('@/assets/joiconleft.gif'),
            position: [800, 420, 100, 100],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: ''
          },
          3: {
            kind: 'object',
            title: 'WC Schlüssel',
            description: 'Schlüssel für das Öffentliche WC!',
            value: 'wc1234',
            img: require('@/assets/wckey.png'),
            position: [520, 500, 80, 50],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: ''
          },
        }
      },
      {
        number: 4,
        title: 'Garage Korridor',
        roomimage: require('@/assets/room4/room4.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'weiter',
            description: '',
            value: '',
            img: '',
            position: [480, 100, 350, 600],
            taken: false,
            keyid: '',
            linkedroomid: 5,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/backbutton.gif'),
            position: [1120, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 0,
            readonly: ''
          },
        }
      },
      {
        number: 5,
        title: 'Treppenhaus',
        roomimage: require('@/assets/room5/room5.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'weiter nach oben',
            description: '',
            value: '',
            img: '',
            position: [780, 10, 450, 300],
            taken: false,
            keyid: '',
            linkedroomid: 6,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/leftbutton.gif'),
            position: [20, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 4,
            readonly: ''
          },
          2: {
            kind: 'door',
            title: 'Öffentliches WC',
            description: 'Verschlossen... ich höre da was knurren... könnte ne Katze sein oder Ralf auf dem WC?',
            value: '',
            img: '',
            position: [80, 100, 250, 450],
            taken: false,
            keyid: 'wc1234',
            linkedroomid: 12,
            readonly: ''
          },
          3: {
            kind: 'door',
            title: 'weiter nach unten',
            description: '',
            value: '',
            img: '',
            position: [850, 540, 400, 300],
            taken: false,
            keyid: '',
            linkedroomid: 13,
            readonly: ''
          },
        }
      },
      {
        number: 6,
        title: 'Wohnungen Korridor',
        roomimage: require('@/assets/room6/room6.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'weiter nach draussen',
            description: '',
            value: '',
            img: '',
            position: [480, 120, 250, 350],
            taken: false,
            keyid: '',
            linkedroomid: 7,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/backbutton.gif'),
            position: [1120, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 5,
            readonly: ''
          },
          2: {
            kind: 'object',
            title: 'Figur',
            description: 'Amibo Figur 2/3',
            value: '',
            img: require('@/assets/amibo2.png'),
            position: [1015, 100, 60, 80],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: ''
          },
        }
      },
      {
        number: 7,
        title: 'Aussenbereich',
        roomimage: require('@/assets/room7/room7.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'weiter eingang',
            description: '',
            value: '',
            img: '',
            position: [1000, 200, 260, 400],
            taken: false,
            keyid: '',
            linkedroomid: 8,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: '',
            position: [50, 200, 360, 400],
            taken: false,
            keyid: '',
            linkedroomid: 6,
            readonly: ''
          },
          2: {
            kind: 'human',
            title: 'Elon Musk',
            description: 'Ralf hat mir gesagt er kauft ein Tesla weil es das BESTE Auto ist. Tipp: Schau mal genauer in den Briefkasten von Marco Krapf.',
            value: '',
            img: require('@/assets/elon.png'),
            position: [750, 300, 130, 300],
            taken: '',
            keyid: '',
            linkedroomid: '',
            readonly: true
          },
        }
      },
      {
        number: 8,
        title: 'Wohnung Eingang',
        roomimage: require('@/assets/room8/room8.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'briefkasten',
            description: '',
            value: '',
            img: '',
            position: [700, 300, 380, 180],
            taken: false,
            keyid: '',
            linkedroomid: 9,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/backbutton.gif'),
            position: [1120, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 7,
            readonly: ''
          },
          2: {
            kind: 'door',
            title: 'eingang',
            description: '',
            value: '',
            img: '',
            position: [280, 100, 230, 600],
            taken: false,
            keyid: '',
            linkedroomid: 11,
            readonly: ''
          },
        }
      },
      {
        number: 9,
        title: 'Briefkasten',
        roomimage: require('@/assets/room9/room9.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'briefkasten krapf',
            description: '',
            value: '',
            img: '',
            position: [100, 450, 380, 250],
            taken: false,
            keyid: '',
            linkedroomid: 10,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/backbutton.gif'),
            position: [1120, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 8,
            readonly: ''
          },
          2: {
            kind: 'object',
            title: 'Figur',
            description: 'Amibo Figur 1/3',
            value: '',
            img: require('@/assets/amibo1.png'),
            position: [1000, 70, 100, 120],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: ''
          },
        }
      },
      {
        number: 10,
        title: 'Briefkasten Fach',
        roomimage: require('@/assets/room10/room10.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/backbutton.gif'),
            position: [1120, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 9,
            readonly: ''
          },
          1: {
            kind: 'object',
            title: 'Schlüssel',
            description: 'Keller Abteil 15b',
            value: 'keller1234',
            img: require('@/assets/key.png'),
            position: [560, 410, 120, 70],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: ''
          },
        }
      },
      {
        number: 11,
        title: 'Wohnung Eingang',
        roomimage: require('@/assets/room11/room11.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/backbutton.gif'),
            position: [1120, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 8,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'Eingang Wohnung von Marco',
            description: 'Verschlossen suche den Schlüssel!',
            value: '',
            img: '',
            position: [650, 100, 400, 700],
            taken: false,
            keyid: 'wohnung1234',
            linkedroomid: 17,
            readonly: ''
          }
        }
      },
      {
        number: 12,
        title: 'Öffentliches WC',
        roomimage: require('@/assets/room12/room12.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/backbutton.gif'),
            position: [1120, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 5,
            readonly: ''
          },
          1: {
            kind: 'human',
            title: 'Garfield',
            description: 'Danke dass Du mich befreit hast. Ich war 1 Woche lang eingesperrt...',
            value: '',
            img: require('@/assets/katze.png'),
            position: [250, 550, 230, 200],
            taken: '',
            keyid: '',
            linkedroomid: '',
            readonly: true
          },
          2: {
            kind: 'object',
            title: 'Schlüssel',
            description: 'Wohnungsschlüssel',
            value: 'wohnung1234',
            img: require('@/assets/keyb.png'),
            position: [1180, 110, 50, 70],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: ''
          },
        }
      },
      {
        number: 13,
        title: 'Treppenhaus Keller',
        roomimage: require('@/assets/room13/room13.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/leftbutton.gif'),
            position: [20, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 5,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'Keller Abteil 15b',
            description: '',
            value: '',
            img: '',
            position: [650, 100, 130, 350],
            taken: false,
            keyid: '',
            linkedroomid: 14,
            readonly: ''
          },
        }
      },
      {
        number: 14,
        title: 'Keller',
        roomimage: require('@/assets/room14/room14.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/leftbutton.gif'),
            position: [20, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 13,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'Keller Abteil 15b',
            description: 'Verschlossen, Schlüssel nötig ...',
            value: '',
            img: '',
            position: [800, 100, 210, 700],
            taken: false,
            keyid: 'keller1234',
            linkedroomid: 15,
            readonly: ''
          },
          2: {
            kind: 'door',
            title: 'Keller Abwasser',
            description: '',
            value: '',
            img: '',
            position: [200, 100, 350, 400],
            taken: false,
            keyid: '',
            linkedroomid: 16,
            readonly: ''
          },
        }
      },
      {
        number: 15,
        title: 'Keller Abteil 15b',
        roomimage: require('@/assets/room15/room15.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/leftbutton.gif'),
            position: [20, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 14,
            readonly: ''
          },
          1: {
            kind: 'object',
            title: 'Schlüssel',
            description: 'Autoschlüssel',
            value: 'auto1234',
            img: require('@/assets/autoschlüssel.png'),
            position: [280, 610, 70, 50],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: ''
          },
          2: {
            kind: 'object',
            title: 'Joycon Rechts',
            description: 'Rechter Joycon Nintendo Switch',
            value: '',
            img: require('@/assets/joyconright.png'),
            position: [1180, 710, 90, 80],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: ''
          },
        }
      },
      {
        number: 16,
        title: 'Abwasser Zentrale',
        roomimage: require('@/assets/room16/room16.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/leftbutton.gif'),
            position: [20, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 14,
            readonly: ''
          },
          1: {
            kind: 'object',
            title: 'Figur',
            description: 'Amibo Figur 3/3',
            value: '',
            img: require('@/assets/amibo3.png'),
            position: [1050, 600, 70, 120],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: ''
          },
          2: {
            kind: 'object',
            title: 'Notiz',
            description: 'Im WC... oben rechts...',
            value: 'wohnung1234',
            img: require('@/assets/note.png'),
            position: [990, 110, 60, 100],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: true
          },
        }
      },
      {
        number: 17,
        title: 'Wohnung',
        roomimage: require('@/assets/room17/room17.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/backbutton.gif'),
            position: [1120, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 11,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: '',
            position: [60, 230, 200, 200],
            taken: false,
            keyid: '',
            linkedroomid: 18,
            readonly: ''
          },
          2: {
            kind: 'object',
            title: 'Nintendo Switch',
            description: 'Konsole',
            value: '',
            img: require('@/assets/switch.png'),
            position: [1180, 400, 60, 35],
            taken: false,
            keyid: '',
            linkedroomid: '',
            readonly: ''
          },
        }
      },
      {
        number: 18,
        title: 'Wohnbereich',
        roomimage: require('@/assets/room18/room18.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/leftbutton.gif'),
            position: [20, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 17,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: '',
            position: [640, 390, 200, 200],
            taken: false,
            keyid: '',
            linkedroomid: 19,
            readonly: ''
          }
        }
      },
      {
        number: 19,
        title: 'Retro Tisch',
        roomimage: require('@/assets/room19/room19.gif'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/leftbutton.gif'),
            position: [20, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 18,
            readonly: ''
          },
          1: {
            kind: 'door',
            title: 'final',
            description: '',
            value: '',
            img: require('@/assets/diplom.gif'),
            position: [600, 250, 130, 100],
            taken: false,
            keyid: '',
            linkedroomid: 20,
            readonly: ''
          }
        }
      },
      {
        number: 20,
        title: 'Ende',
        roomimage: require('@/assets/room20/room20.png'),
        object: {
          0: {
            kind: 'door',
            title: 'zurück',
            description: '',
            value: '',
            img: require('@/assets/leftbutton.gif'),
            position: [20, 700, 130, 130],
            taken: false,
            keyid: '',
            linkedroomid: 18,
            readonly: ''
          }
        }
      },
    ]
  },
  getters: {
    getInventar: state => {
      return state.inventar
    },
    getRoom: state => {
      return state.room
    },
    getAction: state => {
      return state.action
    },
  },
  mutations: {
    addToInventar(state, payload) {
      state.inventar.push({
        title: payload.title,
        value: payload.value,
        img: payload.img,
        description: payload.description
      })
    },
    setRoomObjectState(state, payload) {
      state.room[payload.roomid].object[payload.objectid].taken = true
    },
    setAction(state, value) {
      state.action = value
    },
    initialiseStore(state) {
      // test for local store
      if (localStorage.getItem(AppSettings.vuexLocalStorageName)) {
        // Replace the state object with the stored item
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem(AppSettings.vuexLocalStorageName)))
        );
      }
    }

  }
})
